import { Outlet, useLocation } from 'react-router';

import { useSession } from '@repo/core';

import { LandingPage } from '@/features/landing/landing-page';

/**
 * Decides what `/` means: the public landing page for a signed-out visitor,
 * the app for everyone else.
 *
 * A layer ABOVE <ProtectedLayout>, not a branch inside it, so the guard keeps
 * its one job. Only the exact root is intercepted — a signed-out visitor to
 * `/posts/1` still meets the guard and is sent to /login, which is what a
 * deep link from an old bookmark should do.
 *
 * While the session is still being read it defers to the guard below, whose
 * busy state is already there; flashing the landing page at a signed-in user
 * for one frame would be worse than a spinner.
 */
export function HomeGate() {
  const { isAuthenticated, isLoading } = useSession();
  const { pathname } = useLocation();

  if (!isLoading && !isAuthenticated && pathname === '/') return <LandingPage />;

  return <Outlet />;
}
